import { createConsumer } from "@rails/actioncable";

let consumerInstance = null;

export function getCableConsumer() {
  if (!consumerInstance) {
    consumerInstance = createConsumer();
  }

  return consumerInstance;
}
